import { IJsonQuery } from '@cian/api-models/common/json_query';

import { NonEmptyArray } from './types/common';
import { EFacilityType } from './types';
import { getTermValue } from './helpers';

export function getBathTypes(jsonQuery: IJsonQuery): NonEmptyArray<EFacilityType> | null {
  const hasBath = getTermValue('bath')(jsonQuery);
  const hasShower = getTermValue('shower')(jsonQuery);

  const bathTypes: EFacilityType[] = [];

  if (hasBath) {
    bathTypes.push(EFacilityType.Bath);
  }

  if (hasShower) {
    bathTypes.push(EFacilityType.Shower);
  }

  return bathTypes.length > 0 ? (bathTypes as NonEmptyArray<EFacilityType>) : null;
}
